import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts'

export interface ChartRoleDatum {
  name: string
  value: number
  color: string
  [key: string]: string | number
}

interface RolesDonutChartProps {
  data: ChartRoleDatum[]
  total: number
  clubName: string
}

const EMPTY_STATE_COLOR = '#E5E7EB' // Tailwind gray-200

const RolesDonutChart = ({ data, total, clubName }: RolesDonutChartProps) => {
  const hasData = data.length > 0 && total > 0

  const chartData = hasData
    ? data
    : [
        {
          name: 'No roles scheduled',
          value: 1,
          color: EMPTY_STATE_COLOR,
        },
      ]

  const innerRadius = 80
  const outerRadius = 98

  return (
    <div className="relative mx-auto flex h-64 w-full max-w-[280px] flex-shrink-0 items-center justify-center">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart role="img" aria-label={`${clubName} role distribution chart`}>
          <Pie
            data={chartData}
            dataKey="value"
            startAngle={90}
            endAngle={-270}
            innerRadius={innerRadius}
            outerRadius={outerRadius}
            paddingAngle={chartData.length > 1 ? 2 : 0}
            stroke="none">
            {chartData.map((entry, index) => (
              <Cell
                key={`${entry.name}-${index}`}
                fill={entry.color}
                className={hasData ? '' : 'opacity-70'}
              />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <div className="pointer-events-none absolute flex flex-col items-center justify-center text-center">
        <span className="text-3xl font-semibold text-gray-900">{total}</span>
        <span className="text-xs font-medium uppercase tracking-wide text-gray-500">
          Roles scheduled
        </span>
      </div>
    </div>
  )
}

export default RolesDonutChart
